import Axios from 'axios';
import { all, fork, takeEvery } from 'redux-saga/effects';
import {
	COUPONS_CREATE,
	COUPONS_UPDATE,
	COUPONS_RESET,
	COUPONS_COPY,
	COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS,
	COUPONS_GET_DETAILS,
	COUPONS_GET_OPTIONS,
} from 'Constants/actionTypes';
import { apiUrl } from 'Constants/defaultValues';
import { defaultFetchDataFunc } from 'Util/Saga';
import {
	couponsCreateSuccess,
	couponsCreateFail,
	couponsUpdateSuccess,
	couponsUpdateFail,
	couponsResetSuccess,
	couponsResetFail,
	couponsCopySuccess,
	couponsCopyFail,
	couponsFindAllByPageAndOptionsSuccess,
	couponsFindAllByPageAndOptionsFail,
	couponsGetDetailsSuccess,
	couponsGetDetailsFail,
	couponsGetOptionsSuccess,
	couponsGetOptionsFail,
} from './actions';

export function* watchCouponsCreate() {
	yield takeEvery(COUPONS_CREATE, defaultFetchDataFunc(
		async (data) => {
			const response = await Axios.post(`${apiUrl}/coupon/create`, data);
			return response.data;
		},
		couponsCreateSuccess,
		couponsCreateFail
	));
}

export function* watchCouponsUpdate() {
	yield takeEvery(COUPONS_UPDATE, defaultFetchDataFunc(
		async (data) => {
			const response = await Axios.put(`${apiUrl}/coupon/update`, data);
			return response.data;
		},
		couponsUpdateSuccess,
		couponsUpdateFail
	));
}

export function* watchCouponsReset() {
	yield takeEvery(COUPONS_RESET, defaultFetchDataFunc(
		async (data) => {
			const response = await Axios.put(`${apiUrl}/coupon/reset`, data);
			return response.data;
		},
		couponsResetSuccess,
		couponsResetFail
	));
}

export function* watchCouponsCopy() {
	yield takeEvery(COUPONS_COPY, defaultFetchDataFunc(
		async (data) => {
			const response = await Axios.post(`${apiUrl}/coupon/copy`, data);
			return response.data;
		},
		couponsCopySuccess,
		couponsCopyFail
	));
}

export function* watchCouponsFindAllByPageAndOptions() {
	yield takeEvery(COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS, defaultFetchDataFunc(
		async (data) => {
			const response = await Axios.get(`${apiUrl}/coupon/findAllByPageAndOptions`, { params: data });
			return response.data;
		},
		couponsFindAllByPageAndOptionsSuccess,
		couponsFindAllByPageAndOptionsFail
	));
}

export function* watchCouponsGetDetails() {
	yield takeEvery(COUPONS_GET_DETAILS, defaultFetchDataFunc(
		async (data) => {
			const response = await Axios.get(`${apiUrl}/coupon/details`, { params: { br_no: data } });
			return response.data;
		},
		couponsGetDetailsSuccess,
		couponsGetDetailsFail
	));
}

export function* watchCouponsGetOptions() {
	yield takeEvery(COUPONS_GET_OPTIONS, defaultFetchDataFunc(
		async () => {
			const response = await Axios.get(`${apiUrl}/coupon/getOptions`);
			return response.data;
		},
		couponsGetOptionsSuccess,
		couponsGetOptionsFail
	));
}

export default function* rootSaga() {
	yield all([
		fork(watchCouponsCreate),
		fork(watchCouponsUpdate),
		fork(watchCouponsReset),
		fork(watchCouponsCopy),
		fork(watchCouponsFindAllByPageAndOptions),
		fork(watchCouponsGetDetails),
		fork(watchCouponsGetOptions),
	]);
}
